export default __webpack_public_path__ + "static/burjkhalifaview-94fb0162be62afdb6d961aeec8498816.webp";